import { container } from "tsyringe";
export class UseCaseRatingConverter {
    async convertRating(rating) {
        const ratingConverter = container.resolve("iRatingConverter");
        const convertedRating = await ratingConverter.convertRating(rating);
        return convertedRating;
    }
}
